import {
	get,
	post
} from './http'

import axios from 'axios';
import urlencode from "urlencode";
import baseUrl from '../utils/config.js'

const REPORT_URL_HOST = process.env.REPORT_URL_HOST;

let apiUrl = '';
switch (process.env.NODE_ENV) {
	case 'development':
		apiUrl = baseUrl.devApiHost;
		break;
	case 'release':
		apiUrl = baseUrl.releaseApiHost;
		break;
	case 'tmkRelease':
		apiUrl = baseUrl.tmkReleaseApiHost;
	default:
		apiUrl = baseUrl.proApiHost;
}

export default {

	GetDepartList(token, common = '0', search = "") {
		return get('api/BaseData/GetDepartList', {
			token: token,
			common: common,
			search: search,
		});
	},

	GetStaffList(token, search, type, page, recordCount) {
		return get('api/Personnel/GetStaffList', {
			token: token,
			search: search,
			type: type,
			page: page,
			recordCount: recordCount,
		});
	},

	CreateOrEditDepart(token, data) {
		return post('api/BaseData/CreateOrEditDepart', {
			token: token,
			data: data,
		});
	},

	CreateOrEditStaff(token, data) {
		return post('api/Personnel/CreateOrEditStaff', {
			token: token,
			data: data,
		});
	},

	GetGroupList(token) {
		return get('api/BaseData/GetGroupList', {
			token: token,
		});
	},

	CreateOrEditGroup(token, data) {
		return post('api/BaseData/CreateOrEditGroup', {
			token,
			data
		})
	},

	GetDepartGroupList(token, deptid, status = '') {
		return get('api/BaseData/GetDepartGroupList', {
			token,
			deptid,
			status
		})
	},

	CreateOrEditDepartGroup(token, data) {
		return post('api/BaseData/CreateOrEditDepartGroup', {
			token,
			data
		})
	},



}



// WEBPACK FOOTER //
// ./src/request/personelApi.js